import React from 'react';
import * as PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import { useDispatch } from 'react-redux';

import { actions as confirmVisit } from '../../../../redux/healthboard/requests/confirm-visit-by-patient-req';
import Button from '../../../Button';

function ConfirmVisitByPatientBtn({ userId, appointmentId, type, disabled }) {
  const dispatch = useDispatch();

  const handleConfirmVisitByPatient = e => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(
      confirmVisit.init({
        userId,
        appointmentId,
      }),
    );
  };

  return (
    <Button
      styleName={cn('video-btn', type, { disabled })}
      onClick={handleConfirmVisitByPatient}
      color={type}
      border
    >
      <FormattedMessage id="appointment.list.card.confirm" />
    </Button>
  );
}

ConfirmVisitByPatientBtn.propTypes = {
  userId: PropTypes.number,
  appointmentId: PropTypes.number,
  type: PropTypes.string,
  disabled: PropTypes.bool,
};

ConfirmVisitByPatientBtn.defaultProps = {
  type: 'accent',
};

export default ConfirmVisitByPatientBtn;



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/ConfirmVisitByPatientBtn/index.jsx